<router-outlet name="not_logged_in" *ngIf="!env?.user?.id"></router-outlet>
<router-outlet name="logged_in" *ngIf="env?.user?.id"></router-outlet>
